const RefundSection = () => {
  const policies = [
    '모든 작업은 선결제입니다.',
    '작업 시작 후 단순 변심 환불은 불가합니다.',
    '작업 착수 전(자료 미전달 상태)에 한해 협의 후 취소 가능할 수 있습니다.',
    '작업 범위 외 요청은 추가 비용이 발생합니다.',
    '업종 특성상 노출·성과 보장은 하지 않습니다.',
  ];

  return (
    <section className="py-24 bg-[#fff0f5]">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-3xl md:text-4xl font-black text-navy mb-8">
          환불 및 취소 안내
        </h2>

        <div className="space-y-4">
          {policies.map((policy, index) => (
            <div key={index} className="flex items-start gap-4">
              <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                <i className="ri-checkbox-circle-fill text-neon-pink text-xl"></i>
              </div>
              <p className="text-navy text-sm leading-relaxed">{policy}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RefundSection;